import { combineReducers } from 'redux';

import home from './home';
import explore from './explore';
import city from './city';
import info from './info';
import session from './session';
import toast from './toast';
import app from './app';
import wishlist from './wishlist';
// import inspiration from './inspiration';
// import calendar from './calendar';
import search from './search';
// import toast from './toast';
import lx from './lx';
import trip from './trip';
import gallery from './gallery';
import popup from './popup';
import filter from './filter';
import localTable from './localTable';
// import payment from './payment';
// import { routerReducer } from 'react-router-redux';
import article from './article';
import availability from './availability';

export default combineReducers({
  // routing: routerReducer,
  home,
  explore,
  city,
  info,
  session,
  toast,
  wishlist,
  // inspiration,
  // calendar,
  search,
  // toast,
  filter,
  lx,
  trip,
  gallery,
  popup,
  // payment,
  app,
  article,
  availability,
  localTable,
});
